import {decorate, inject, injectable} from '@yosmanyga/di';
import {AxiosInstance} from './Axios';

class RestorationApi {
    constructor(private axios: AxiosInstance) {
    }

    collect = async (from: number, limit: number): Promise<LogType[]> => {
        const {data} = await this.axios
            .withAuthentication()
            .get('/v1/collect-logs', {
                params: {
                    from: from,
                    limit: limit,
                },
            });

        return data as LogType[];
    };

    count = async (): Promise<number> => {
        const {data} = await this.axios
            .withAuthentication()
            .get('/v1/count-logs');

        return data as number;
    };

    restore = async (log: LogType) => {
        await this.axios
            .withAuthentication()
            .withPlatform()
            .withLanguage()
            .post('/v1/restore-game', {
                before: log.order,
            });
    };
}

decorate(injectable(), RestorationApi);
decorate(inject(AxiosInstance), RestorationApi, 0);

export type LogType = {
    command: string;
    order: number;
};

export {RestorationApi};
